/**
 * Convert a workspace name to a URL-friendly slug
 * Examples:
 *   "My Workspace" -> "my-workspace"
 *   "John's Company" -> "johns-company"
 *   "Test & Dev" -> "test-dev"
 */
export function workspaceNameToSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    // Replace spaces and special characters with hyphens
    .replace(/[^a-z0-9]+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+|-+$/g, '')
    // Ensure it's not empty
    || 'workspace';
}

/**
 * Convert a workspace slug back to a display name (limited, since slug loses information)
 * This is mainly for display purposes when we don't have the actual workspace name
 */
export function slugToDisplayName(slug: string): string {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Derive a default transaction ID prefix from workspace name (e.g. "Personal Finance" -> "PF").
 * Used when creating a workspace so Settings > Workspace shows a value in deployed and local.
 */
export function defaultTransactionIdPrefixFromName(workspaceName: string): string {
  const trimmed = workspaceName.trim();
  if (!trimmed) return "";
  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    const initials = words.slice(0, 3).map((w) => w.replace(/[^a-zA-Z0-9]/g, "").charAt(0)).join("");
    return initials.toUpperCase().slice(0, 4) || trimmed.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 4);
  }
  return trimmed.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 4) || "";
}
